import {Component} from 'react';

export default class Dummy extends Component {

    constructor(props) {
        super(props);
        this.state = {
            dataReady: false
        };
        this.extractParams = ::this.extractParams;
    }

    static clearCanvas(canvasId) {
        let cvs = document.getElementById(canvasId);
        if (cvs.getContext) {
            let ctx = cvs.getContext('2d');
            ctx.clearRect(0, 0, cvs.width, cvs.height);
        }
    }

    extractParams() {
        let disabled = [];
        let params = [];
        let ps = [];
        if (this.props.ps) {
            ps = this.props.ps;
            ps.forEach(p => {
                let val = p;
                disabled.push(val.disabled);
                params.push(val.cleaned)
            });
        }
        else disabled = [true];
        params.unshift(disabled.some(element => {
            return element;
        }));
        return params;
    }

    componentDidMount() {
        if (this.props.canvas_id) {
            this.paintCanvas(this.props.canvas_id, ...(this.extractParams()));
        }
    }

    componentDidUpdate() {
        if (this.props.ps) {
            if (this.props.canvas_id) {
                Dummy.clearCanvas(this.props.canvas_id);
                this.paintCanvas(this.props.canvas_id, ...(this.extractParams()));
            }
        }
    }

}




// WEBPACK FOOTER //
// ./src/lib/core/Dummy/index.jsx